import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import '@mdi/font/css/materialdesignicons.css'

const camTheme = {
  dark: false,
  colors: {
    primary:   '#004e8f',
    secondary: '#3b977a',
    error:     '#e53935',
  },
}

export default createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: 'camTheme',
    themes: { camTheme },
  },
  icons: { defaultSet: 'mdi' },
})
